// Mapeia o status técnico do card (open/waiting/won/lost) para o rótulo e
// a cor exibidos, de acordo com a categoria do pipeline (sales/post_sales).
// Os valores técnicos no banco são sempre os mesmos para os dois tipos de
// funil — só a apresentação muda.

export const STATUS_META = {
  sales: {
    open: { label: 'Aberto', color: 'blue' },
    won: { label: 'Ganho', color: 'teal' },
    lost: { label: 'Perdido', color: 'ruby' },
  },
  post_sales: {
    open: { label: 'Produzindo', color: 'blue' },
    waiting: { label: 'Aguardando', color: 'amber' },
    won: { label: 'Finalizado', color: 'teal' },
    lost: { label: 'Cancelado', color: 'ruby' },
  },
};

const COLOR_CLASSES = {
  slate: {
    border: 'border-t-n-slate-6',
    bar: 'bg-n-slate-6',
    text: 'text-n-slate-10',
    badgeBg: 'bg-n-slate-3',
    badgeText: 'text-n-slate-11',
  },
  blue: {
    border: 'border-t-n-blue-9',
    bar: 'bg-n-blue-9',
    text: 'text-n-blue-11',
    badgeBg: 'bg-n-blue-3',
    badgeText: 'text-n-blue-11',
  },
  amber: {
    border: 'border-t-n-amber-9',
    bar: 'bg-n-amber-9',
    text: 'text-n-amber-10',
    badgeBg: 'bg-n-amber-3',
    badgeText: 'text-n-amber-11',
  },
  teal: {
    border: 'border-t-n-teal-9',
    bar: 'bg-n-teal-9',
    text: 'text-n-teal-10',
    badgeBg: 'bg-n-teal-3',
    badgeText: 'text-n-teal-11',
  },
  ruby: {
    border: 'border-t-n-ruby-9',
    bar: 'bg-n-ruby-9',
    text: 'text-n-ruby-9',
    badgeBg: 'bg-n-ruby-3',
    badgeText: 'text-n-ruby-11',
  },
};

export function statusesForCategory(category) {
  const meta = STATUS_META[category] ?? STATUS_META.sales;
  return Object.keys(meta);
}

export function statusMeta(category, status) {
  const meta = STATUS_META[category] ?? STATUS_META.sales;
  return meta[status] ?? meta.open;
}

export function statusLabel(category, status) {
  return statusMeta(category, status).label;
}

export function statusColorClasses(category, status) {
  const { color } = statusMeta(category, status);
  return COLOR_CLASSES[color] ?? COLOR_CLASSES.slate;
}
